export const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
    }

    export const slugify = (input: string): string => {
        return input
          .toLowerCase()
          .trim()
          .replace(/[^\w\s-]/g, "") // Remove non-word characters except space and dash
          .replace(/\s+/g, "-"); // Replace spaces with hyphens
      };
      